export default "__VITE_ASSET__11113bfd__"